import { render, staticRenderFns } from "./CircleLoader.vue?vue&type=template&id=0ffc1124&scoped=true"
import script from "./CircleLoader.vue?vue&type=script&lang=js"
export * from "./CircleLoader.vue?vue&type=script&lang=js"
import style0 from "./CircleLoader.vue?vue&type=style&index=0&id=0ffc1124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffc1124",
  null
  
)

export default component.exports